var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgItalic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 48l.332-3.25 4.84-.464c.929-.065 1.06-.33 1.193-1.325l5.304-37.922c.132-.996.067-1.26-.861-1.328L18 3.247 18.398 0h17.769l-.4 3.247-5.037.532c-.996.132-1.063.264-1.195 1.26l-5.369 37.857c-.132 1.06-.132 1.193.861 1.325l4.907.53L29.602 48H11.833z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cGF0aCBkPSJNMTEuODMzMzIgNDhsLjMzMi0zLjI0OTg0IDQuODM5NjgtLjQ2NDI2Yy45Mjg1My0uMDY0NzggMS4wNjA3OS0uMzI5MyAxLjE5MzA1LTEuMzI1MzFMMjMuNTAyIDUuMDM5NDJjLjEzMjI2LS45OTYwMS4wNjc0OC0xLjI2MDUzLS44NjEwNS0xLjMyODAxbC00LjYzOTk0LS40NjQyNkwxOC4zOTc3OSAwaDE3Ljc2ODg4bC0uMzk5NDggMy4yNDcxNS01LjAzNjcyLjUzMTc0Yy0uOTk2MDEuMTMyMjYtMS4wNjM0OS4yNjQ1Mi0xLjE5NTc1IDEuMjYwNTNMMjQuMTY2IDQyLjg5NThjLS4xMzIyNiAxLjA2MDc5LS4xMzIyNiAxLjE5MzA1Ljg2MTA1IDEuMzI1MzFsNC45MDcxNi41MjkwNUwyOS42MDIyMSA0OEgxMS44MzMzMnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";
export { SvgItalic as ReactComponent };